application.utilities = new Utilities();
function Utilities()
{

	var self = this;

	self.awake = function()
	{
		
	};

	self.ready = function()
	{
		TwitterStringToLinks();
		PDFLinkFormatter();
	};

	function TwitterStringToLinks()
	{
		var twitterFeed = $( '#twitter-feed' );

		if ( twitterFeed.length ) {
			
			twitterFeed.find( '.tweet-link-convert' ).each( function( e ){

				var tweetString = $(this).html();


				tweetString = tweetString.replace( /https(\S+)/g, '<a rel="external" href="http$1">https$1</a>')
										 .replace( /@(\S+)/g, '<a rel="external" href="https://twitter.com/#!/$1">@$1</a>')
										 .replace( /#(\S+)/g, '<a rel="external" href="https://twitter.com/search?q=%23$1">#$1</a>');

				$(this).html( tweetString );
		

			} );

		}
	}

	// PDFLinkFormatter
	// Formats anchor tags with '.pdf' in the href to have the proper classes, labels, and targets
	function  PDFLinkFormatter()
	{
		$( 'a' ).each( function(){

			if( $( this ).attr( 'href' ).indexOf( '.pdf' ) != -1)
			{
				// If there is no PDF label, add one
				if( $( this ).html().indexOf( 'PDF' ) == -1 && $( this ).parent().html().indexOf( 'PDF' ) == -1 ) 
					$( this ).append( ' <span class="footnote"> (PDF)' );

				// If it doesn't have the proper class, add it
				if( !$( this ).hasClass( 'pdf-link' ) )
					$( this ).addClass( 'pdf-link' );

				// If the target isn't _blank, make it so
				if( $( this ).attr( 'target' ) != '_blank' )
					$( this ).attr( 'target', '_blank' );
			}
		} );
	}

	ApplicationObject.call( this );
}
Utilities.prototype = Object.create( ApplicationObject.prototype );


/*
	Dictionary
	Collection of Key/Value pairs used for storing and retrieving data via unique IDs
*/
function Dictionary()
{

	var self = this;

	self.keys = [];
	self.values = [];

	self.length = 0;

	self.add = function( key, value )
	{
		if( !self.keys.includes( key ) )
		{
			self.keys.push( key );
			self.values[ self.keys.length - 1 ] = value;
			self.length = self.keys.length;
		}
		else
		{
			debug.logWarning( 'Key already exists, updating key value' );
			self.set( key, value );
		}
	};

	self.remove = function( key )
	{
		if( self.keys.includes( key ) )
		{
			var idx = self.keys.indexOf( key );
			self.keys.splice( idx, 1 );
			self.values.splice( idx, 1 );
			self.length = self.keys.length;
		}
	};

	self.get = function( key )
	{
		return self.getByIndex( self.keys.indexOf( key ) );
	};

	self.getByIndex = function( i )
	{
		var val = self.values[ i ];
		if( val !== undefined ) return val;
		else
			debug.log( 'key not found in Dictionary' );
	};

	self.set = function( key, value )
	{
		if( self.keys.includes( key ) )
		{
			self.values[ self.keys.indexOf( key ) ] = value;
		}
		else
		{
			debug.logWarning( 'Key doesn\'t exist, adding key value' );
			self.add( key, value );
		}
	};

}

/* 
	String Format emulator
	Replaces the bracketted "placeholders" with the arguments passed
	Usage:
	"Hello {0} {1}".format( 'Whoopi', 'Goldberg' );
	prints "Hello Whoopi Goldberg"
*/ 
String.prototype.format = function()
{
    var self = this,
        i = arguments.length;

    while (i--) {
        self = self.replace( new RegExp('\\{' + i + '\\}', 'gm'), arguments[i] );
    }
    return self;
};